<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import { MobileModule } from './store/modules/mobile'
export default {
    mounted() {
        if (navigator.userAgent.indexOf('iPhone') === -1) {        
            const appStyle = document.getElementById('app').style
            appStyle.height = '100%'
            appStyle.overflow = 'auto'
            const bodyStyle = document.body.style
            bodyStyle.height = '100%'
            bodyStyle.overflow = 'hidden'
            const htmlStyle = document.getElementsByTagName('html')[0].style
            htmlStyle.height = '100%'
            htmlStyle.overflow = 'hidden'
        } else {
            MobileModule.setOrientation(window.orientation)
            window.addEventListener('orientationchange', this.orientationchange)
        }
    },
    methods: {
        orientationchange() {
            MobileModule.setOrientation(window.orientation)
        }
    }
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

html, body {
    width: 100%;
    padding-right: 0px !important;
    @include scroll-bar(6px)
}

* {
    margin: 0px;
    padding: 0px;
}
* { 
    -webkit-tap-highlight-color:rgba(0,0,0,0); 
}

#app {
    font-family: 'Microsoft YaHei', 'PingFang SC','Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 16px;
    margin-top: 0px;
    @include scroll-bar(6px)
}
</style>
